import styled from "styled-components";

export const MapContainerWrapper = styled.div`
  display: block;
  height: 246px;
  border-radius: 10px;
  margin-top: 16px;
`;
